

<!-- <div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
       <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
                <div class="col-md-12 marquee-text" *ngIf="adminData?.length != 0">
                  <div class="marquee-box">
                    <h4><i class="fa fa-microphone"></i> News</h4>
                    <marquee scrollamount="5">
                        {{adminHeading}}
                    </marquee>
                  </div>
                </div>
                <div class="col-md-12">
                    <div class="promo-banner">
                        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                              <div class="carousel-item"  *ngFor="let image of banner;let i = index;" [ngClass]="(i === 0) ? 'active' : ''" data-bs-interval="5000">
                                <img src="{{image.bannerUrl}}" class="d-block w-100" alt="...">
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="game-highlight-wrap">
                        <h3 class="d-none d-lg-block">Highlights</h3>
                        <div class="game-menu-tab">
                            <a (click)="openModalSearch(search)" class="a-search d-block d-lg-none" data-bs-toggle="modal" role="button">Search</a>
                            <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                <li class="nav-item d-none d-lg-block" role="presentation" *ngFor="let sports of allSportsList;let i= index" (click)="goToDashboard(sports.name,sports.sport_id,sports)">
                                    <button class="nav-link" [class.active]='sportName == sports.name'  id="pills-1-tab" data-bs-toggle="pill" data-bs-target="#pills-1" type="button" role="tab" aria-controls="pills-1" aria-selected="true"><i class="icon-cricket"></i> {{sports.name}}</button>
                                </li>
                                <li class="nav-item d-block d-lg-none" role="presentation" *ngFor="let sports of mobileAllSportsList;let i= index" (click)="goToDashboard(sports.name,sports.sport_id,sports)">
                                   <button class="nav-link" id="pills-1-tab" [ngClass]="{'newlaunch':sports.sport_id <= -100 }" [class.active]='sportName == sports.name'  data-bs-toggle="pill" data-bs-target="#pills-1" type="button" role="tab" aria-controls="pills-1" aria-selected="true">
                                       
                                        <img src="assets/images/icon/{{sports.sport_id}}.svg" style="height:29px !important;width:32px !important;">
                                         {{sports.name}}</button>
                                  </li>
                            </ul>
                            <h3 class="d-block d-lg-none">Highlights</h3>
                            <div class="tab-content" id="pills-tabContent" *ngIf="dataLength != 0">
                                <div class="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab" tabindex="0">
                                    <table class="table table-hover">
                                        <thead>
                                            <th class="view-mobile" colspan="2"></th>
                                            <th class="text-center">1</th>
                                            <th class="text-center">X</th>
                                            <th class="text-center">2</th>
                                            <th class="text-center"></th>
                                        </thead>  
                                        <tbody *ngFor="let matchData of homeData ;let i = index;">
                                            <tr>
                                                <td (click)="matchDetail(matchData)" style="cursor:pointer">
                                                    <a class="match-name"><span>{{matchData?.match_name}}</span></a>
                                                    <span class="in_play" *ngIf="matchData?.inplay == true || matchData?.manualInplay == true">In-Play</span>
                                                    <p class="match-time" *ngIf="matchData?.inplay != true || matchData?.manualInplay != true">{{(matchData?.match_date |  date :'dd-MM-yyyy HH:mm')}}</p>
                                                    <span class="in_play" *ngIf="(matchData?.match_tv_url != null || matchData?.match_tv_url != undefined) && (matchData?.inplay == true )"><i class="fa fa-television"></i></span>
                                                </td>
                                                <td class="game-market">
                                                    <span class="game-fancy" *ngIf="matchData?.enable_fancy == 1">F</span>
                                                    <span class="game-sportbook">S</span>
                                                </td>
                                                <td class="count">
                                                    <span class="back">{{ matchData?.runners[0] == undefined || (matchData?.runners[0]?.ex?.availableToBack) == null ||matchData?.runners[0].ex?.availableToBack[0]?.price == undefined ||matchData?.runners[0].ex?.availableToBack[0]?.price == '--' ? '0' :
                                                        matchData?.runners[0]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[0]?.ex?.availableToLay[0]?.price
                                                        == undefined || matchData?.runners[0]?.ex?.availableToLay[0]?.price == '--' || (matchData?.runners[0]?.ex?.availableToLay) == null ? '0' :
                                                        matchData?.runners[0]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count">
                                                    <span class="back"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToBack).length == 0 || (matchData?.runners[2]?.ex?.availableToBack) == null ? '0.0' :
                                                        matchData?.runners[2]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToLay).length == 0 || (matchData?.runners[2]?.ex?.availableToLay) == null ? '0.0' :
                                                        matchData?.runners[2]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count position-relative">
                                                    <span class="back"> {{matchData?.runners[1] == undefined || (matchData?.runners[1]?.ex?.availableToBack) == null  ||matchData?.runners[1]?.ex?.availableToBack[0]?.price
                                                        == undefined || matchData?.runners[1]?.ex?.availableToBack[0]?.price == '--'? '0' :
                                                        matchData?.runners[1]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[1]?.ex?.availableToLay[0]?.price == undefined || (matchData?.runners[1]?.ex?.availableToLay) == null || matchData?.runners[1]?.ex?.availableToLay[0]?.price == '--'? '0' :
                                                        matchData?.runners[1]?.ex?.availableToLay[0]?.price}}</span>
                                                 </td>
                                                <td class="ps-0" (click)="favourite(matchData.match_id)" style="cursor:pointer">
                                                    <a title="Add to Multi Markets" class="add-pin" 
                                                    [ngClass]="{'pin-on':(matchData?.my_favorites).length != 0,'pin-off':(matchData?.my_favorites).length == 0}"><i class="bi bi-pin-fill"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>  
                                    </table>
                                </div>
                            </div>                                                                                    
                        </div>
                    </div>
                </div>
                <app-footer></app-footer>
            </div>
        </main>
        <app-right-sidebar></app-right-sidebar>             
    </div>
   <app-footer-main></app-footer-main>
</div> -->

<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="latest-event d-xl-none">
        <div class="latest-event-item" style="width: fit-content;" *ngFor="let matchData of homeDataFav">
            <a class="blink_me" (click)="matchDetail(matchData)">
                
                <img _ngcontent-kph-c80="" alt="" src="assets/img/{{matchData?.sport_id}}.png">
                <span style="text-align:center"> &nbsp;{{matchData?.match_name}}</span></a>
        </div>
    </div>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                    <ul class="nav nav-tabs sport-tab">
                        <!-- <li class="nav-item"><a class="nav-link active" (click)="goToAll('All')">Home</a></li> -->
                        <li class="nav-item"><a class="nav-link active" (click)="inplay()">In-Play</a></li>
                        <li class="nav-item"><a class="nav-link " (click)="dashboard()">SportS</a></li>
                        <li class="nav-item"><a class="nav-link " routerLink="/world-casino/QT">Qtech</a></li>
                        <li class="nav-item"><a class="nav-link" routerLink="/world-casino/DC">Dream Casino</a></li>
                        <!-- <li class="nav-item" *ngFor="let sports of allSportsList;let i= index"
                          (click)="goToDashboard(sports.name,sports.sport_id,sports)"><a class="nav-link"
                            [ngClass]="{'newlaunch':sports.sport_id <= -100 }">{{sports.name == 'Soccer' ? 'Football' : sports.name}}</a></li> -->
                    </ul>
                </div>
                <div class="col-md-10 featured-box">

                    <div class="">
                        <div class="latest-event d-xl-desktop-none">
                            <div class="latest-event-item" *ngFor="let matchData of homeDataFav">
                                <a class="blink_me" (click)="matchDetail(matchData)">
                                    <img _ngcontent-kph-c80="" alt="" src="assets/img/{{matchData?.sport_id}}.png">
                                    <span style="text-align:center"> &nbsp;{{matchData?.match_name}}</span></a>
                            </div>
                        </div>
                           
         
                        <div class="pb-4 mobilepb-0">
                            <ul role="tablist" id="home-events" class="nav nav-tabs">
                                <ng-container *ngFor="let sports of mobileAllSportsList;let i= index" >
                                <li class="nav-item" (click)="goToDashboard(sports.name,sports.sport_id,sports)">
                                    <a href="javascript:void(0)" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#home-tab" role="tab" class="nav-link" [class.active]='sportName == sports.name'>
                                        <img src="assets/images/icon/{{sports.sport_id}}.png" alt="" class="hide-large"> {{sports.name == 'Soccer' ? 'Football' : sports.name}}
                                    </a>
                                </li>
                            </ng-container>
                            </ul>
                            <div class="tab-content" *ngIf="homeData?.length != 0">
                                <div class="tab-pane fade show active" id="home-tab" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                                    <div class="coupon-card coupon-card-first mobile-scroll">
                                        <div class="card-content" *ngIf="dataLength?.length != 0">
                                            <table class="table coupon-table mobile-coupon-table">
                                                <thead class="hide-small">
                                                    <tr>
                                                        <th style="width: 63%;">Game</th> 
                                                        <th colspan="2">1</th> 
                                                        <th colspan="2">X</th> 
                                                        <th colspan="2">2</th>
                                                    </tr>
                                                </thead>
                                                 
                                                <tbody *ngFor="let matchData of homeData;let i = index;">
                                                    <tr>
                                                        <td (click)="matchDetail(matchData)">
                                                            <div class="game-name">
                                                                <span _ngcontent-neh-c98="" class="sport-icon"><img _ngcontent-neh-c98="" alt="" src="assets/img/{{matchData?.sport_id}}.png"></span>
                                                                <a class="text-dark">
                                                                    
                                                                    <span class="match-name">
                                                                       
                                                                        {{matchData?.match_name}}</span>
                                                                    <span class="hide-small" > / {{(matchData?.match_date |  date :'MMM d yyyy HH:mma')}}</span>
                                                                    <span class="hide-large match-date" *ngIf="matchData?.inplay != true || matchData?.manualInplay != true">{{(matchData?.match_date |  date :'MMM d yyyy HH:mma')}}</span>
                                                                </a>
                                                            </div>
                                                            <div class="game-icons">
                                                                <span class="game-icon inplay" *ngIf="matchData?.inplay == true || matchData?.manualInplay == true">
                                                                    <span class="active"></span>
                                                                </span>
                                                                <span class="game-icon icon-tv" *ngIf="(matchData?.match_tv_url != null || matchData?.match_tv_url != undefined) "><i class="fas fa-tv"></i></span>
                                                                <span class="game-icon" *ngIf="matchData?.enable_fancy == 1">
                                                                    <img src="assets/diamond_img/ic_fancy.png" class="fancy-icon hide-small">
                                                                    <img src="assets/diamond_img/ic_fancy-m.png" class="fancy-icon hide-large">
                                                                </span>
                                                                <span class="game-icon" *ngIf="sportName == 'Cricket'">
                                                                    <img src="assets/diamond_img/ic_bm.png" class="fancy-icon hide-small">
                                                                    <img src="assets/diamond_img/ic_bm-m.png" class="fancy-icon hide-large">
                                                                </span>
                                                                <!-- <span class="game-icon" *ngIf="sportName != 'Cricket'"><img src="assets/diamond_img/ic_vir.png" class="fancy-icon"></span> -->
                                                            </div>
                                                        </td>
                                                        <td class="hide-large">
                                                            <div class="text-center game-home"><b>1</b></div>
                                                            <div class="text-center game-home"><b>X</b></div> 
                                                            <div class="text-center game-home"><b>2</b></div>
                                                        </td>
                                                        <td>
                                                            <button class="back">{{ matchData?.runners[0] == undefined || (matchData?.runners[0]?.ex?.availableToBack) == null ||matchData?.runners[0].ex?.availableToBack[0]?.price == undefined ||matchData?.runners[0].ex?.availableToBack[0]?.price == '--' ? '-' :
                                                                matchData?.runners[0]?.ex?.availableToBack[0]?.price}}</button>
                                                        </td>
                                                        <td>
                                                            <button class="lay">{{matchData?.runners[0]?.ex?.availableToLay[0]?.price
                                                                == undefined || matchData?.runners[0]?.ex?.availableToLay[0]?.price == '--' || (matchData?.runners[0]?.ex?.availableToLay) == null ? '-' :
                                                                matchData?.runners[0]?.ex?.availableToLay[0]?.price}}</button>
                                                        </td>
                                                        <td>
                                                            <button class="back"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToBack).length == 0 || (matchData?.runners[2]?.ex?.availableToBack) == null ? '-' :
                                                                matchData?.runners[2]?.ex?.availableToBack[0]?.price}}</button>
                                                        </td>
                                                        <td>
                                                            <button class="lay"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToLay).length == 0 || (matchData?.runners[2]?.ex?.availableToLay) == null ? '-' :
                                                                matchData?.runners[2]?.ex?.availableToLay[0]?.price}}</button>
                                                        </td>
                                                        <td>
                                                            <button class="back"> {{matchData?.runners[1] == undefined || (matchData?.runners[1]?.ex?.availableToBack) == null  ||matchData?.runners[1]?.ex?.availableToBack[0]?.price
                                                                == undefined || matchData?.runners[1]?.ex?.availableToBack[0]?.price == '--'? '-' :
                                                                matchData?.runners[1]?.ex?.availableToBack[0]?.price}}</button>
                                                        </td>
                                                        <td>
                                                            <button class="lay">{{matchData?.runners[1]?.ex?.availableToLay[0]?.price == undefined || (matchData?.runners[1]?.ex?.availableToLay) == null || matchData?.runners[1]?.ex?.availableToLay[0]?.price == '--'? '-' :
                                                                matchData?.runners[1]?.ex?.availableToLay[0]?.price}}</button>
                                                        </td>
                                                    </tr>
                                                </tbody> 
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-content" *ngIf="dataLength == 0">
                                <div class="tab-pane fade show active" id="home-tab" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                                    <div class="coupon-card coupon-card-first mobile-scroll">
                                        <div class="card-content">
                                            <table class="table coupon-table">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center" style="line-height: 32px;">No real-time records found</td>
                                                    </tr>
                                                </tbody> 
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="home-products-container" *ngIf="casinoItems == true">
                            <div class="row row5 hide-large">
                                <div class="col-md-12">
                                    <h4 class="text-uppercase pb-3">Our Casino</h4>
                                </div>
                            </div>
                            <div class="row row5">
                                <div class="col-md-12 casino-list">
                                    <a *ngFor="let list of exchangeGameList;let i = index; ">
                                        <div class="d-inline-block casinoicons"  routerLink="/casino-detail/{{list.code}}/{{list.providerCode}}">
                                            <img src="{{list.thumb}}" class="img-fluid">
                                            <div class="casino-name">{{list?.name}}</div>
                                            <!-- <div class="new-launch-casino"><img src="assets/diamond_img/offer-patch.png" class="hide-small">
                                                <span class="hide-large">New Launch</span>
                                            </div> -->
                                        </div>
                                    </a>
                                    <!-- <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Race 20-20</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/queen.jpg" class="img-fluid">
                                            <div class="casino-name">Casino Queen</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/cricketv3.jpg" class="img-fluid">
                                            <div class="casino-name">5Five Cricket</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/andar-bahar2.jpg" class="img-fluid">
                                            <div class="casino-name">Andar Bahar 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Dragon Tiger 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Lucky 7 - B</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Teenpatti 2.0</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Cricket Match</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Casino Meter</div>
                                        </div>
                                    </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>

<app-footer-main></app-footer-main>

<!-- Search Modal -->
<ng-template #search>
    <div ngbDropdown class="search-top dropdown">
      <form class="d-flex position-relative">
          <span class="search-back ui-link"></span>
          <input ngbDropdownToggle class="form-control" id="dropdownMenuLink"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
          [(ngModel)]="searchSport" [ngModelOptions]="{standalone: true}" placeholder="Search Events">
          <span class="search-clear" (click)="searchSport = '';modalRef.hide()"></span>
          <span class="search-collapse"></span>
          <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a ngbDropdownItem class="dropdown-item" *ngFor="let sport of homeData |search: searchSport :'match_name'">
                  <div class="event-info" (click)="matchDetailDrop(sport)">
                      <div class="event-team">
                          <div class="team-name">{{sport?.match_name}}</div>
                      </div>
                  </div>
              </a>
          </div>
          
      </form>                    
    </div>
  </ng-template>

  <!-- Auto load Modal -->
<ng-template #autoShowPopup>
    <header class="modal-header">
        <h5 class="modal-title"></h5>
        <a aria-label="Close" class="close"  data-bs-dismiss="modal" aria-label="Close"
        (click)="modalRef.hide()">×</a>
    </header>
    <div class="modal-body">
        <div class="home-banner hide-small" style="background-image: url(&quot;assets/banners/banner-pop.png&quot;);">
        </div>
        <img class="home-banner hide-large" src="assets/banners/banner-pop.png">
    </div>
  </ng-template>